import { render, staticRenderFns } from "./MgmInviteRecords.vue?vue&type=template&id=3465ee56&scoped=true&"
import script from "./MgmInviteRecords.vue?vue&type=script&lang=js&"
export * from "./MgmInviteRecords.vue?vue&type=script&lang=js&"
import style0 from "./MgmInviteRecords.vue?vue&type=style&index=0&id=3465ee56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3465ee56",
  null
  
)

export default component.exports